import { render, staticRenderFns } from "./TopicList.vue?vue&type=template&id=4f39e45c"
import script from "./TopicList.vue?vue&type=script&lang=js"
export * from "./TopicList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports